import type { Report } from '../../types';
import { planeModulBuchung, type ModulBuchung } from '../bestandteile/modulBuchung';

/**
 * Die Leistungsbuchung des SiGe-Handbuchs nach der Freigabe (Plan
 * Paketposition B5, Betreiber 19.10.2026: „Buchung direkt nach der Erstellung
 * anbieten" — bis hierhin buchte das Handbuch nichts).
 *
 * Das Handbuch hat KEINEN eigenen Zuordnungswert (LV_JE_UNTERLAGE kennt keine
 * Handbuchposition, und ein neuer Wert ist ausdruecklich nicht gewollt). Der
 * Regelfall ist deshalb Fall 2: das Handbuch ist Bestandteil einer
 * Paketposition, die Freigabe erledigt ihn per Trigger. Fall 1 gibt es nur
 * ueber die Auswahl aus ALLEN Positionen (Muster SiGe-Plan
 * `fallbackToAllServices`), ohne Vorauswahl.
 *
 * Journalquelle 'einweisung' — dieselbe wie bei Vorankuendigung, Unterlage
 * und SiGe-Plan, deren Huelle das Handbuch ist: die Dokumentmodule spiegeln
 * ihre Ausgabebuchungen seit S4b unter diesem Wert, `source` hat keinen CHECK.
 *
 * Rein; Muster B (`onUpdate`, dann `queueJournalMirror` mit der Vormerkung).
 */

/** Der Protokolltext — nennt die freigegebene Fassung. */
export const handbuchBuchungsText = (fassungNr: string | number | null | undefined, menge: number, einheit: string): string => {
    const nr = String(fassungNr ?? '').trim();
    return `SiGe-Handbuch freigegeben (${nr ? `Fassung ${nr}` : 'ohne Fassungsnummer'}) (${menge} ${einheit})`;
};

export const planeHandbuchBuchung = (a: {
    report: Report;
    serviceId: string;
    hours: number;
    fassungNr?: string | number | null;
    performerName: string;
    jetzt?: Date;
    neueId?: () => string;
}): ModulBuchung | null => planeModulBuchung({
    report: a.report,
    serviceId: a.serviceId,
    hours: a.hours,
    beschreibung: (menge, einheit) => handbuchBuchungsText(a.fassungNr, menge, einheit),
    performerName: a.performerName,
    source: 'einweisung',
    jetzt: a.jetzt,
    neueId: a.neueId,
});
